import { render, staticRenderFns } from "./EditSize.vue?vue&type=template&id=2d6475c7&scoped=true"
import script from "./EditSize.vue?vue&type=script&lang=js"
export * from "./EditSize.vue?vue&type=script&lang=js"
import style0 from "./EditSize.vue?vue&type=style&index=0&id=2d6475c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6475c7",
  null
  
)

export default component.exports